module.exports = __webpack_public_path__ + "static/media/All That I Want.4563721f.jpg";